import React from 'react'
import { Button } from '@material-ui/core';

interface DeleteButtonProps {
  onClick: () => void;
}

function DeleteButton({ onClick }: DeleteButtonProps) {
  return (
    <Button color="primary" onClick={onClick} size="small">
      Delete
    </Button>
  );
}

export default DeleteButton;
